/**
 * BrandMark — 딥서치 심볼.
 *
 * ⚠️ 이 도형은 **브랜드 자산이다. 손으로 다시 그리지 않는다.**
 * 좌표·색은 정본 SVG(design/DeepSearch Hub/uploads/DeepSearch.svg)를 그대로 옮겼다.
 * 3겹이 같은 간격(4.889)으로 쌓이고 색이 단계마다 다르다 — 단색+opacity 로
 * 흉내 내면 납작하고 탁해진다(실제로 그렇게 그려져 있었다).
 *
 * 아이콘은 Lucide, 브랜드 심볼은 정본 — 둘 다 "직접 그리지 않는다"가 규칙이다.
 */

/** 정본 3겹 — 아래(진함) → 위(옅음) */
const LAYERS: { d: string; fill: string; opacity?: number }[] = [
  { d: "M16 12.4443L29.335 20.8897L16 29.335L2.66504 20.8897L16 12.4443Z", fill: "#004FFA" },
  { d: "M16 7.55469L29.335 16L16 24.4454L2.66504 16L16 7.55469Z", fill: "#1A82FF", opacity: 0.7 },
  { d: "M16 2.66504L29.335 11.1104L16 19.5557L2.66504 11.1104L16 2.66504Z", fill: "#70C0FF", opacity: 0.4 },
];

export interface BrandMarkProps {
  className?: string;
  /** 생성 중 — 세 겹이 차례로 밝아진다 (.loading, dcf.css 의 dsPulse) */
  loading?: boolean;
}

export function BrandMark({ className, loading }: BrandMarkProps) {
  return (
    <svg
      className={[className, loading && "loading"].filter(Boolean).join(" ")}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
    >
      {LAYERS.map((l) => (
        <path key={l.d} fillRule="evenodd" clipRule="evenodd" d={l.d} fill={l.fill} opacity={l.opacity} />
      ))}
    </svg>
  );
}
